import { cn } from "@/lib/utils";
import fbIcon from "@/entities/accounts/components/plaform-icon/icons/fb.image.svg";
import gbIcon from "@/entities/accounts/components/plaform-icon/icons/gb.image.svg";
import igIcon from "@/entities/accounts/components/plaform-icon/icons/ig.image.svg";
import lnIcon from "@/entities/accounts/components/plaform-icon/icons/ln.image.svg";
import otIcon from "@/entities/accounts/components/plaform-icon/icons/ot.image.svg";
import piIcon from "@/entities/accounts/components/plaform-icon/icons/pi.image.svg";
import scIcon from "@/entities/accounts/components/plaform-icon/icons/sc.image.svg";
import thIcon from "@/entities/accounts/components/plaform-icon/icons/th.image.svg";
import ttIcon from "@/entities/accounts/components/plaform-icon/icons/tt.image.svg";
import twIcon from "@/entities/accounts/components/plaform-icon/icons/tw.image.svg";
import ytIcon from "@/entities/accounts/components/plaform-icon/icons/yt.image.svg";

const iconMap: Record<string, string> = {
  facebook: fbIcon,
  googlemybusiness: gbIcon,
  instagram: igIcon,
  linkedin: lnIcon,
  other: otIcon,
  pinterest: piIcon,
  snapchat: scIcon,
  threads: thIcon,
  tiktok: ttIcon,
  twitter: twIcon,
  youtube: ytIcon,
};

const platformAliases: Record<string, string> = {
  FB: "facebook",
  GMB: "googlemybusiness",
  IG: "instagram",
  LI: "linkedin",
  OT: "other",
  PI: "pinterest",
  SC: "snapchat",
  TH: "threads",
  TT: "tiktok",
  TW: "twitter",
  X: "twitter",
  YT: "youtube",
};

export function normalizeSelectorPlatform(platformType?: string) {
  if (!platformType) return "other";
  return (
    platformAliases[platformType.toUpperCase()] || platformType.toLowerCase()
  );
}

export function SelectorPlatformIcon({
  type,
  altText,
  className,
}: {
  type?: string;
  altText?: string;
  className?: string;
}) {
  const normalizedType = normalizeSelectorPlatform(type);
  return (
    <img
      src={iconMap[normalizedType] || otIcon}
      alt={altText || ""}
      className={cn("inline-block", className)}
    />
  );
}
